module.exports = __webpack_public_path__ + "media/images/article/2022_07-5b4a611253ef2bab599fbdd1acb1529b.png";